var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-indicator"}},[(_vm.visible)?_c('div',{staticClass:"connection-indicator",class:_vm.stateClass,attrs:{"title":_vm.title}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }